import Component from '../abstracts/Component';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import wnumb from 'wnumb';

export default class PriceRangeComponent extends Component {

  get COMPONENTNAME() {
    return 'PriceRangeComponent';
  }

  get SELECTORS() {
    return {
      minInput: '[data-input-min]',
      maxInput: '[data-input-max]',
      rangeSlider: '[data-range-slider]',
    };
  }

  get CLASSNAMES() {
    return {
      active: 'active',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.minVal = parseInt(this.$component.dataset.rangeMin);
    this.maxVal = parseInt(this.$component.dataset.rangeMax);
    this.currentMin = parseInt(this.$component.dataset.min);
    this.currentMax = parseInt(this.$component.dataset.max);
    this.minInput = this.$component.querySelector(this.SELECTORS.minInput);
    this.maxInput = this.$component.querySelector(this.SELECTORS.maxInput);
    this.rangeSlider = this.$component.querySelector(this.SELECTORS.rangeSlider);
    this.currency = this.$component.dataset.currency !== undefined ? this.$component.dataset.currency :
      this.$component.querySelector('[data-currency]') !== null ? this.$component.querySelector('[data-currency]').dataset.currency : '';
    // extra components
    this.applyFilter = false;

    this.resetSlider = this.resetSlider.bind(this);
    this.enableSlider = this.enableSlider.bind(this);
    this.disableSlider = this.disableSlider.bind(this);
  }

  render() {
    super.render();
    this.init();
    this.setSliderChangeHandler();
    this.bindEvents();
  }

  init() {
    let rangeAllSliders = {};
    let data = this.$component.dataset;
    let all = data.all;
    let allSplitted = all.split("|");
    let cnt = allSplitted.length;
    let setMinIndexTo = 0;
    let setMaxIndexTo = cnt -1;

    this.updateInputs();

    if(cnt >= 2) {
      for(var i = 0; i < cnt; i++) {
        let perc = Math.floor(100*i/(cnt-1));
        if(i == setMinIndexTo) {
          rangeAllSliders["min"] = parseInt(allSplitted[i]);
        } else if(i == setMaxIndexTo) {
          rangeAllSliders["max"] = parseInt(allSplitted[i]);
        } else {
          rangeAllSliders[perc + "%"] = parseInt(allSplitted[i]);
        }
      }
    }

    noUiSlider.create(this.rangeSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      range : rangeAllSliders,
      snap : true,
      tooltips: true,
      format: wnumb({
        'prefix': this.currency + ' ',
        'decimals': 0,
        'thousand': ''
      })
    });
  }

  setSliderChangeHandler() {
    const target = this.$component;
    const handleSlider = () => {
      const values = this.rangeSlider.noUiSlider.get();
      this.currentMin = parseInt(values[0].toString().replace(this.currency + ' ', ''));
      this.currentMax = parseInt(values[1].toString().replace(this.currency + ' ', ''));
      this.updateInputs();
      if(this.applyFilter) {
        this.$emit(this.$customEvents.FILTERS_EVENTS.currentPriceRangeInput,{domComponent: this.$component});
        this.$emit(this.$customEvents.FILTERS_EVENTS.launchQuery);
      }
    };
    this.rangeSlider.noUiSlider.on('change', handleSlider);
  }

  updateInputs() {
    if((this.minInput.value != '' && isNaN(this.currentMin) === false && this.minInput.value != this.currentMin) ||
      (this.maxInput.value != '' && isNaN(this.currentMax) === false && this.maxInput.value != this.currentMax)) {
      this.applyFilter = true;
    }
    this.minInput.value = this.currentMin.toString().replace('.-', '');
    this.maxInput.value = this.currentMax.toString().replace('.-', '');
  }

  resetSlider() {
    let currency = this.currency;
    let values = this.rangeSlider.noUiSlider.get();
    // reset sliders
    this.rangeSlider.noUiSlider.set([this.minVal, this.maxVal]);
    this.currentMin = parseInt(values[0].toString().replace(currency + ' ', ''));
    this.currentMax = parseInt(values[1].toString().replace(currency + ' ', ''));
    this.updateInputs();
    this.$component.classList.remove(this.CLASSNAMES.active);
  }

  //To disable
  disableSlider() {
    document.querySelectorAll(this.SELECTORS.rangeSlider).forEach(item => {
      if(item == null) return;
      item.setAttribute('disabled', '');
    });
  }

  //To re-enable
  enableSlider() {
    document.querySelectorAll(this.SELECTORS.rangeSlider).forEach(item => {
      if(item == null) return;
      item.removeAttribute('disabled');
    });
  }

  getAllRanges(element) {
    if(element != null) {
      let all = element.dataset.all;
      let allSplitted = all.split("|");
      // ascending order set
      const sortAsc = (a, b) => a - b;
      allSplitted.sort(sortAsc);

      return allSplitted;
    } else {
      return;
    }
  }

  buildQuery() {
    // take values
    if(document.querySelector('.w-price-range') == null) {
      return '';
    }

    let query = '';
    let count;
    let element = this.$component;
    let allSplitted = this.getAllRanges(element);
    let minVal = this.minInput != null ? this.minInput.value : element.querySelector(this.SELECTORS.minInput).value;
    let maxVal = this.maxInput != null ? this.maxInput.value : element.querySelector(this.SELECTORS.maxInput).value;
    let rangeMin = element.dataset.rangeMin;
    let rangeMax = element.dataset.rangeMax;
    let facetName = element.dataset.facetName;

    if(allSplitted != null && (rangeMin != minVal || rangeMax != maxVal)) {

      query = ':';

      for(var i = 0; i < allSplitted.length; i++) {
        if(parseInt(allSplitted[i]) <= minVal) {
          // if is less , i jumpt it
          continue;
        } else if((parseInt(allSplitted[i]) <= maxVal) && count == null) {
          // first price filter
          query += facetName + ":" + allSplitted[i];
          count = 1;
        } else if((parseInt(allSplitted[i]) <= maxVal) && count != null) {
          // first price filter
          query += ":" + facetName + ":" + allSplitted[i];
        } else {
          break;
        }
      }
      if(query == ':') {
        //avoids broken query
        query += facetName + ":" + maxVal;
      }

      element.classList.add(this.CLASSNAMES.active);
    } else {
      element.classList.remove(this.CLASSNAMES.active);
    }
    return query;
  }

  bindEvents(){
    this.$on(this.$customEvents.PRICE_RANGE_FILTER.reset, this.resetSlider);
    this.$on(this.$customEvents.PRICE_RANGE_FILTER.disable, this.disableSlider);
    this.$on(this.$customEvents.PRICE_RANGE_FILTER.enable, this.enableSlider);
  }
}
